<script setup>
defineProps({
  hasB2CStyles: {
    type: Boolean,
    default: false
  }
});
defineEmits(["zoomIn", "zoomOut"]);
</script>

<template>
    <div
        class="flex flex-col bg-white shadow border overflow-hidden"
        :class="
  hasB2CStyles ? 'w-8 h-16 m-3 justify-center border-zinc-200 rounded' : 'w-10 h-20 m-2 border-slate-300 rounded-lg'
"
    >
        <button
            type="button"
            :class="
  hasB2CStyles ? 'h-full border-b border-zinc-200 hover:bg-zinc-100' : 'flex-grow hover:bg-slate-100'
"
            aria-label="Zoom in"
            @click="$emit('zoomIn')"
        >
            <IconPlus
                class="m-auto size-5"
                :class="hasB2CStyles ? 'text-zinc-800' : 'text-slate-500'"
            />
        </button>
        <button
            type="button"
            :class="
  hasB2CStyles ? 'h-full hover:bg-zinc-100' : 'flex-grow hover:bg-slate-100'
"
            aria-label="Zoom out"
            @click="$emit('zoomOut')"
        >
            <IconMinus
                class="m-auto size-5"
                :class="hasB2CStyles ? 'text-zinc-800' : 'text-slate-500'"
            />
        </button>
    </div>
</template>
